import { render, staticRenderFns } from "./IndustryNewsPage.vue?vue&type=template&id=1756e1ea"
import script from "./IndustryNewsPage.vue?vue&type=script&lang=js"
export * from "./IndustryNewsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports